import { micIcon } from "../../utils/constants";

function MicComponent() {
  return (
    <>
      <div className="mic-container">
        <img src={micIcon} alt="" />
      </div>
    </>
  );
}

export default MicComponent;
